import { Box, TextNew } from '@jfs/ui-new'
import { Container } from '../../../comps/Container'
// import { Box, ButtonNew, Icon, SearchBar, Spacer, SpacerNew, Tab, TextNew } from '@jfs/ui-new'
import { useNavigation } from '@react-navigation/core'
import { useEffect } from 'react'
import { Image, ImageSourcePropType } from 'react-native'
import { RootStore, useLazyApiData, useStores } from '../../../data/store'
import { Screens } from '../../../nav/Screens'
import { ShimmerEffect } from '../../MobileRecharge/PlanSkeleton'
import { CategoryGrid, displayNameToSvgId } from './CategoryGrid'
import { AepsButton } from '../../../comps/AepsButton'

const findCategoryDetails = (billerCategories: any[], categoryId: number) => {
  for (const group of billerCategories) {
    const category = group.catetoryList.find((c: any) => c.id === categoryId)
    if (category) {
      return {
        categoryName: category.name,
        categoryId: category.id,
        displayName: category.displayName,
      }
    }
  }
  return null
}
export const BbpsCustomerOnboard = () => {
  const BBPSLogo: ImageSourcePropType = require('../../../assets/images/BBPSLogo.png')

  const navigation = useNavigation()
  const { getProductListBC, billerCategories, callGetProductListBC, bcAppInfo, agentSession } = useStores((root) => ({
    getProductListBC: root.BillPaymentAgentOnboard.getProductListBC,
    billerCategories: root.BillPaymentAgentOnboard.billerCategories,
    callGetProductListBC: root.BillPaymentAgentOnboard.callGetProductListBC,
    bcAppInfo: root.bcAppInfo,
    agentSession: root.agent.session,
  }))
  const [fetchCategories, categoriesResponse] = useLazyApiData(getProductListBC, { autoRun: false })
  const [lazycallGetProductListBC, callGetProductListBCHandler] = useLazyApiData(callGetProductListBC)
  const state = categoriesResponse?.state

  useEffect(() => {
    fetchCategories()
    // lazycallGetProductListBC()
  }, [])
  let productListResponse: any
  let categoryIddd: any

  const handlefetchCategories = () => {
    fetchCategories()
  }

  const handleCategoryClick = async (categoryId: number) => {
    const categoryDetails = findCategoryDetails(billerCategories, categoryId)

    if (!categoryDetails) {
      console.error('Category details not found for ID:', categoryId)
      return
    }

    const { categoryName, displayName } = categoryDetails

    try {
      console.log('Category Clicked. Calling callGetProductListBC for categoryId:', categoryId)
      console.log('Rahul SEE value of billerCategories:', billerCategories)
      console.log('Rahul SEE value of categoriesResponse?.state', categoriesResponse?.state)
      console.log('Rahul SEE value of b categoriesResponse', categoriesResponse)
      console.log('Rahul SEE value of b categoryDetails', categoryDetails)
      let productListResponse = ''
      // productListResponse = await callGetProductListBC(categoryId)
      console.log('Successfully received API Response for Product List:', productListResponse)
      ;(navigation as any).navigate(Screens.ADD_CUSTOMER, {
        categoryName: categoryName,
        categoryId: categoryId,
        displayName: displayName,
        productList: productListResponse,
      })

      console.log('Navigation successful to Screens.ADD_CUSTOMER')
    } catch (error) {
      console.error('Failed to fetch product list or navigate:', error)
    }
  }

  const isSessionDataReady = bcAppInfo?.userAccessToken && bcAppInfo?.userIdentifier && agentSession?.CHANNEL_ID

  if (state === 'pending' || state === undefined || !isSessionDataReady) {
    return (
      <Container showFooter={true} overflow="scroll">
        {/* <Box flex={1} justifyContent="center" alignItems="center">
          <LoaderNew type="large" color="BRAND_PRIMARY_ACTION" />
          <SpacerNew size={15} />
          <TextNew>Loading biller categories and session data...</TextNew>
        </Box> */}
        <ShimmerEffect />
      </Container>
    )
  }
  if (state === 'rejected' || billerCategories.length === 0) {
    return (
      <Container showFooter={true} overflow="scroll">
        <Box justifyContent={'space-between'} height={'100%'} flexDirection={'row'}>
          <Box>
            <TextNew>Failed to load categories or no categories available.</TextNew>
          </Box>
          <Box width={'100%'} marginBottom={'12'} paddingBottom={2} >
            <AepsButton onPress={handlefetchCategories} title={'Refresh'}  />
          </Box>
        </Box>
      </Container>
    )
  }
  return (
    <>
      <Container showFooter={false} overflow="scroll">
        <Box padding={16} backgroundColor="BG_PRIMARY" flexDirection={'column'} gap={10}>
          <Box flexDirection={'row'} justify={'space-between'}>
            <TextNew fontSize={25} fontWeight="bold">
              Bills
            </TextNew>
            {/* <TextNew fontSize={14} color="BRAND_COLOR_GRAY_1">
              {RootStore.agent.agentInfo.agentUserName || 'Manish Kumar Tiwari'}
            </TextNew> */}
          </Box>
          <Box flexDirection="row" alignItems="center">
            <TextNew fontSize={14} color="BRAND_COLOR_GRAY_1">
              Powered by
            </TextNew>
            <Image source={BBPSLogo} style={{ width: 80, height: 20, resizeMode: 'contain' }} />
          </Box>
        </Box>
        {billerCategories.map((group) => (
          <Box key={group.categoryType} marginBottom={30} marginTop={30} width={'100%'}>
            <Box>
              <TextNew fontSize={28} lineHeight={50} color="BLACK">
                {group.categoryType} {/* Dynamic Category Header */}
              </TextNew>
            </Box>
            <CategoryGrid data={group.catetoryList} svgMap={displayNameToSvgId} onPress={handleCategoryClick} />
          </Box>
        ))}
      </Container>
    </>
  )
}

// useEffect(() => {
//   if (callGetProductListBCHandler.state === 'fulfilled') {
//     try {
//       console.log('Inside UseEffect handleCategoryClick')
//       console.log('Inside UseEffect handleCategoryClick')
//       console.log('Inside UseEffect handleCategoryClick')
//       console.log('Inside UseEffect handleCategoryClick')

//       console.log(
//         'Avinash Manish from useEffect we are going to navigate to Screen Recharge bill payments inside useEffect:',
//       )
//       // navigation.reset({
//       //   index: 0,
//       //   routes: [
//       //     {
//       //       name:(Screens.RECHARGE_BILL_PAYMENTS as never)
//       //     },
//       //   ],
//       // })
//       ;(navigation as any).navigate(Screens.RECHARGE_BILL_PAYMENTS, {
//         productList: productListResponse,
//         categoryId: categoryIddd,
//       })
//       console.log('from useEffect we navigated successfully after handleCategoryClick')
//     } catch (error) {
//       console.error('from useEffect Inside useEffect Failed to fetch product list and navigate:', error)
//       console.log(' from useEffect failed to navigate')
//     }
//   }
// }, [aaaa, callGetProductListBC, callGetProductListBCHandler, lazycallGetProductListBC])

// const [lazygetProductListBC, getProductListBCHandler] = useLazyApiData(getProductListBC)
// lazygetProductListBC();
// useEffect(()=>{
//   if(getProductListBCHandler.state==='fulfilled'){
//     console.log('We are Entering BbpsCustomerOnboard Page')

//       const reasonCode = agentExistsHandler?.data?.responseObj?.agent?.agentStatus?.reasonCode
//       console.log(reasonCode, 'reasonCode:::::')
//       navigation.reset({
//         index: 0,
//         routes: [
//           {
//             name:
//               reasonCode === '0'
//                 ? (Screens.BBPS_HOME_SCREEN as never)
//                 : reasonCode === '1'
//                 ? (Screens.ADD_CUSTOMER as never)
//                 : (Screens.BBPS_LOAD_INITIAL as never),
//           },
//         ],
//       })

//   }
// }, [getProductListBCHandler])

// {
/* The hardcoded sections below are now replaced by the map above, so they can be removed:
        <Box>
          <TextNew fontSize={28} lineHeight={50} color="BLACK">
            {'Recharge'}
          </TextNew>
        </Box>
        <CategoryGrid data={popularGroup} svgMap={displayNameToSvgId} onPress={handleCategoryClick} />
        <Box marginBottom={30} marginTop={30} width={'100%'}>
          <Box>
            <TextNew fontSize={28} lineHeight={50} color="BLACK">
              {'Utilities'}
            </TextNew>
          </Box>
          <CategoryGrid data={utilitiesGroup} svgMap={displayNameToSvgId} onPress={handleCategoryClick} />
        </Box>
        <Box marginBottom={30} marginTop={30} width={'100%'}>
          <Box>
            <TextNew fontSize={28} lineHeight={50} color="BLACK">
              {'Finances'}
            </TextNew>
          </Box>
          <CategoryGrid data={financeGroup} svgMap={displayNameToSvgId} onPress={handleCategoryClick} />
        </Box>
        <Box marginBottom={30} marginTop={30} width={'100%'}>
          <Box>
            <TextNew fontSize={28} lineHeight={50} color="BLACK">
              {'Others'}
            </TextNew>
          </Box>
          <CategoryGrid data={othersGroup} svgMap={displayNameToSvgId} onPress={handleCategoryClick} />
        </Box> 
        */
// }

// const apiResponse = {
//   responseStatus: { code: '000', message: 'Request processed successfully.' },
//   responseObject: [
//     {
//       categoryGroup: {
//         categoryType: 'Utilities',
//         catetoryList: [
//           { id: 100032, name: 'NCMC Recharge', displayName: 'NCMC Recharge', status: 'Active' },
//           { id: 100033, name: 'MobileRecharge', displayName: 'Mobile Recharge', status: 'Active' },
//           { id: 100034, name: 'FASTag', displayName: 'FASTag', status: 'Active' },
//           { id: 100035, name: 'Electricity', displayName: 'Electricity', status: 'Active' },
//           { id: 100036, name: 'DTH', displayName: 'DTH', status: 'Active' },
//           { id: 100037, name: 'Book LPG', displayName: 'Book LPG', status: 'Active' },
//           { id: 100038, name: 'Credit Card', displayName: 'Credit', status: 'Active' },
//           { id: 100039, name: 'JioFibre', displayName: 'JioFibre', status: 'Active' },
//           { id: 100040, name: 'Postpaid', displayName: 'Postpaid', status: 'Active' },
//         ],
//       },
//     },
//   ],
// }
